import React from 'react';
import { studioInfo } from '../mock';
import { Instagram, Facebook } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Studio Info */}
          <div>
            <h3 className="text-2xl font-black text-white mb-4 uppercase tracking-tight">
              {studioInfo.name.split(' ')[0]} <span className="text-red-600">Tattoo</span> {studioInfo.name.split(' ')[2]}
            </h3>
            <p className="text-gray-400 mb-4">{studioInfo.tagline}</p>
            <p className="text-gray-500 text-sm">{studioInfo.address}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={scrollToTop}
                  className="text-gray-400 hover:text-red-600 transition-colors duration-200">

                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-400 hover:text-red-600 transition-colors duration-200">

                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('artists')}
                  className="text-gray-400 hover:text-red-600 transition-colors duration-200">

                  Artists
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-red-600 transition-colors duration-200">

                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('booking')}
                  className="text-gray-400 hover:text-red-600 transition-colors duration-200">

                  Book Now
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-red-600 transition-colors duration-200">
                <a href={`tel:${studioInfo.phone}`}>{studioInfo.phone}</a>
              </li>
              <li className="hover:text-red-600 transition-colors duration-200">
                <a href={`mailto:${studioInfo.email}`}>{studioInfo.email}</a>
              </li>
              <li className="text-gray-500 text-sm mt-4">{studioInfo.hours}</li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-white font-bold uppercase text-sm mb-4 tracking-wider">Follow Us</h4>
            <div className="flex gap-3 mb-6">
              <a
                href={studioInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 rounded-lg flex items-center justify-center hover:bg-red-600 hover:border-red-600 transition-all duration-300 group">

                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
              <a
                href={studioInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 rounded-lg flex items-center justify-center hover:bg-red-600 hover:border-red-600 transition-all duration-300 group">

                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
              <a
                href={studioInfo.socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 rounded-lg flex items-center justify-center hover:bg-red-600 hover:border-red-600 transition-all duration-300 group">

                <svg className="w-5 h-5 text-gray-400 group-hover:text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
            </div>
            <Button
              onClick={() => scrollToSection('booking')}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider text-sm">

              Book Appointment
            </Button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} {studioInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <button className="text-gray-500 hover:text-red-600 transition-colors duration-200">
              Privacy Policy
            </button>
            <button className="text-gray-500 hover:text-red-600 transition-colors duration-200">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;